<template>
  <form class="combination-form-root">
    <div class="form-fields">
        <div class="combination-main-section">
            <div class="combination-form-select">
                <label>{{$t('unit')}}:</label>
                <v-select 
                    class="v-select-field"
                    :getOptionLabel="o => `${o.NMFILIAL}`"
                    :filterable="true" 
                    :options="attractivenessFilialOptions"
                    v-model="formData.unidade">
                </v-select>
            </div>
            <label> {{$t('import_type')}}: </label>
            <div class="mode-switch">
                <div @click="switchMode('Adicionar')" 
                    class="mode-switch-option"
                    :class="{active: mode === 'Adicionar'}"> 
                {{$t('add')}} </div>
                <div @click="switchMode('Sobrepor')" 
                    class="mode-switch-option"
                    :class="{active: mode === 'Sobrepor'}"> 
                {{$t('overlap')}} </div>
            </div>
        </div>
    </div>
    <div class="button-container"> 
        <button class="button ghost" @click="modal.hide('Attractiveness-form-modal')"> <i class="fas fa-times"></i> {{$t('cancel')}} </button>     
        <button type="submit" @click="saveCombination" class="button" style="font-size: 17px;"> <i class="fas fa-check"></i> {{$t('save')}} </button>
    </div>
  </form>
</template>

<script>
import vSelect from "vue-select";
import Provider from '@/application/providers/PlatesProvider'
import PlateService from '@/application/services/Plates'
import Util from '@/application/libs/util'
import { t } from 'i18next'

const requiredErrorMessage = t('required_field');
const atLeastOneErrorMessage = t('select_at_least_one_field');

export default {

  name: 'AttractivenessForm',

  props: ['modal'],

  components: {
    "v-select": vSelect
  },

  data() {
    return {
        attractivenessFilialOptions: [],
        mode: 'Adicionar',
        formData: {
            unidade: null,
        }
    };
  },
  
  mounted() {
      this.onFilialSearch();
  },
  methods:{
      onFilialSearch: function() {
          Provider.getFilial().then((filial) => {
              this.attractivenessFilialOptions = filial
          });
      },
      switchMode: function(newMode) {
          this.mode = newMode;
      },
      validateFields: function(data) {
          let isValid = true;

          if(!data.CDFILIORIGEM && !data.CDFILIORIGEM !== undefined){
              isValid = false;
          }
          return isValid;
      },
      saveCombination: function() {
          const CDFILIORIGEM = 
                this.formData && 
                this.formData.unidade && 
                this.formData.unidade.CDFILIAL 
                    ? this.formData.unidade.CDFILIAL 
                    : undefined;
          const IDCOMBINACAO = this.mode === 'Adicionar' ? 'ADD' : 'OVERLAP';  
          const dataToSave = {
              CDFILIORIGEM
          };

          const validationResult = this.validateFields(dataToSave);
          if(validationResult){
              if(IDCOMBINACAO === 'OVERLAP'){
                let CONFIRM_PUBLISH_CARD = t('popup_attractiveness');
          		Util.showConfirmationDialog(this.$modal, {
            		onModalClose: function( confirmPublishCard ){
            			if(confirmPublishCard) {
                            PlateService.deleteAttractiveness()
                              .then(keys => {
                                  PlateService.insertAttractiveness(dataToSave)
                                  .then(value =>{
                                      this.$emit('AttractivenessSaved');
                                      this.modal.hide('Attractiveness-form-modal');
                                      Util.showSuccessNotification({ title: t('saved_attractiveness')})
                                  })
                                  .catch(e => {
                                    Util.showErrorNotification({ title: t('unable_to_save_attractiveness'), text: e.error});
                                  });
                              })
                              .catch(e => {
                                  Util.showErrorNotification({ title: t('unable_to_save_attractiveness'), text: e.error});
                              });
        				}
        			}.bind(this)
        		}, CONFIRM_PUBLISH_CARD);
              }else{
                  PlateService.insertAttractiveness(dataToSave)
                  .then(keys => {
                      this.$emit('AttractivenessSaved');
                      this.modal.hide('Attractiveness-form-modal');
                      Util.showSuccessNotification({ title: t('saved_attractiveness')})
                  })
                  .catch(e => {
                      Util.showErrorNotification({ title: t('unable_to_save_attractiveness'), text: e.error});
                  });
              }
          }
      }
  }
};
</script>

<style lang="less">
    .v--modal-overlay .v-modal-overflow-visible{
        overflow: visible;
        background-color: white;
    }
    
    .combination-form-select{
        &.errors {
            .v-select-field .vs__dropdown-toggle{
                border: red solid 1px;
            }
        }
    }

</style>

<style lang="less" scoped>

.combination-form-root{
    margin: 10px;
    display: flex;
    flex-direction: column;

    .button-container{
        display: flex;
        justify-content: center;
        margin-bottom: 25px;


        .button{
            min-width: 100px;
            padding: 6px 15px;
            margin: auto 3px;

            &.ghost{
                background-color: white;
                box-shadow: none;
                color: #dc143d;
                border: 1px solid #dc143d;
                padding: 5px 14px;

                &:hover{
                    color: #212146;
                    border: 1px solid #212146;
                }
            }
        }
    }

    .mode-switch{
        margin-top: 10px;
        font-size: .9rem;
        border-radius: 5px;
        width: fit-content;
        color: #DC143D;
        border: 1px solid #DC143D;
        cursor: pointer;
        user-select: none;
        width: 100%;
        display: flex;

        .mode-switch-option{
            flex: 1;
            text-align: center;
            border-radius: 5px;
            padding: 7px;
            transition: .3s background-color;
            &:hover{
                background-color: #fcdee4;
            }

            &.active{
                background-color: #DC143D;
                color: white;
            }
        }
    }

    .combination-main-section{
        border-bottom: #20212424 1px solid;
        padding: 15px 19px;
        margin: 10px;

        .field-group{
            .field-error{
                font-size: .9rem;
                display: block;
                color: red;
                margin: 2.5px 0;
                min-height: 1rem;
            }

            &.errors{
                border: red 1px solid;
                margin-top: 10px;
                padding: 5px;
                border-radius: 5px;
            }
        }

    }

    .combination-sub-section{
        .combination-main-section;
        margin-top: 0;
        border: none; 
    }

    .combination-form-field{

        &.margin-top-20{
            margin-top: 20px;
        }

        &.no-margin-top{
            margin-top: 0;
        }

        margin-top: 10px;


        label{
            width: 200px;
            text-align: right;
        }

        .field-error{
            font-size: .9rem;
            display: block;
            color: red;
            margin: 2.5px 0;
            min-height: 1rem;
        }

    }

    .combination-form-select{
            
        
        .combination-form-field;
        .v-select {
            margin-top: 1px;
        }
    }

    .combination-form-number-field{
        .combination-form-field;

        .number-input{
            appearance: none;
            outline: none;
            border: 1px solid;
            padding: 5px 0 6px 8px;
            background: none;
            border: 1px solid #c4c4c4;
            border-radius: 4px;
            display: block;
            width: calc(100% - 8px);
            font-size: 1em;
            color: #333346;
            line-height: 1.4;
        }
    }
}

</style>